export default __webpack_public_path__ + "static/media/cloud-pointer.4b8482ea.svg";